@if (contentListSource.pageItems.length && !triggerAnimation) {
  <ul class="content-list-source-array-thumbnail">
    @for (pageItem of contentListSource.pageItems; track ((contentListSource.page || 1) + '-' + (pageItem.listItem.object.relation_id || pageItem.listItem.object.artifact_id || $index))) {
      <li
        class="content-list-source-array__item"
        [id]="'item-' + $index"
        [style.--enter-index]="$index"
      >
        <div class="list-thumbnail__item">
          <div class="list-thumbnail__row">
            <div
              class="content-list-source-array-thumbnail__first-column"
              [ngClass]="{'relatedObjectView': pageItem.relatedObject}"
            >
              <div class="list-thumbnail__first-container">
                @if (hasOperationMenu) {
                  <div class="checkbox-underlay">
                    <mat-checkbox
                      class="white-bg-in-checkbox"
                      (click)="setSelected($event, pageItem)"
                      (keydown)="null"
                      [disabled]="contentListSource.operationContainer.art.read_only"
                      [(ngModel)]="pageItem.checked"
                    ></mat-checkbox>
                  </div>
                }

                <app-object-url
                  [object]="pageItem.relatedObject"
                  [aClass]="'thumbnail-url-source-content'"
                  class="content-list-source-array-thumbnail__object-url"
                >
                  <div class="object-url-content">
                    @if (pageItem.thumbnailInfo.thumbnail_url || pageItem.thumbnailInfo.thumbnail_id) {
                      <app-thumbnail
                        [item]="pageItem.thumbnailInfo"
                        [stylingClass]="'thumbnail-image thumbnail-fixed-height'"
                      ></app-thumbnail>
                    }
                    @else {
                      <i class="icon-image imgIcon"></i>
                    }
                  </div>
                </app-object-url>
              </div>

              <div
                class="list-thumbnail__second-container"
                [ngClass]="{'no-image': !(pageItem.thumbnailInfo.thumbnail_url || pageItem.thumbnailInfo.thumbnail_id)}"
              >
                @if (pageItem.relatedObject?.overview) {
                  <app-search-columns-overview-fields
                    class="list-thumbnail__object-overview overview-fields__content-list"
                    [searchObject]="pageItem.relatedObject"
                    [viewName]="contentListSource.searchContainer.searchResultViewName"
                  ></app-search-columns-overview-fields>
                }
              </div>
            </div>

            <div class="content-list-source-array-thumbnail__second-column">
              <div class="list-thumbnail__object-overview">
                <div class="headline-container">
                  <i class="icon-link"></i>

                  <span class="bold">
                    {{ 'TRANS__OBJECT_CONTENT_LIST_SOURCE_ARRAY_ITEMS__RELATION_HEADLINE' | translate }}
                  </span>
                </div>

                <ul class="content-list-source-array-thumbnail__second-column-items">
                  @for (field of pageItem.listItem.fields; track $index) {
                    <li>
                      <span class="content-list-source-array-thumbnail__second-column-item-title">
                        {{field.title | translate}}:
                      </span>

                      <span>
                        {{field.value}}
                      </span>
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
      </li>
    }
  </ul>
}
